//imports
import { all } from 'redux-saga/effects';

//Views
import usersResetCognitoSagas from 'Modules/users/.components/resetSubUserPassword/redux/saga';
import sendWelcomeEmailSagas from 'Modules/users/.components/sendWelcomeEmail/redux/saga';


//merge sagas
export default function* rootSaga() {
    yield all([
        usersResetCognitoSagas(),
        sendWelcomeEmailSagas()
    ]);
}